import { KeyboardEvent } from "react";

export const blockNonAmountKeys = (event: KeyboardEvent<HTMLInputElement>) => {
  if (event.key.length === 1 && !/[\d.,\s]/.test(event.key)) {
    event.preventDefault();
  }
};
